import { gql } from '@apollo/client';

export const EXPORT_ACCOUNTING_DATA = gql`
    mutation ExportAccountingData(
        $startDate: Date!
        $endDate: Date!
        $exportType: String
        $status: String
        $invoiceType: String
    ) {
        exportAccountingData(
            startDate: $startDate
            endDate: $endDate
            exportType: $exportType
            status: $status
            invoiceType: $invoiceType
        ) {
            exportUrl
            recordCount
            filename
        }
    }
`;
